import React from "react";

export const WHATSAPP_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M11.9936 0.00635343C5.37007 0.00775884 0.00178953 5.37833 0.00319495 12.0018C0.00366342 14.2953 0.661821 16.5406 1.89953 18.4714L0.0336457 23.3126C-0.0657174 23.5701 0.0624568 23.8594 0.319929 23.9587C0.377505 23.9809 0.43864 23.9923 0.500338 23.9922C0.557586 23.9925 0.614411 23.9827 0.668239 23.9632L5.6653 22.1793C11.2875 25.6809 18.6839 23.9617 22.1854 18.3394C25.687 12.7171 23.9679 5.32085 18.3456 1.8193C16.4398 0.63228 14.2389 0.0041516 11.9936 0.00635343Z"
        fill="#4CAF50"
      />
      <path
        d="M17.7113 14.049C17.7113 14.049 16.487 13.4494 15.7204 13.0496C14.853 12.6029 13.8336 13.4394 13.3538 13.9151C12.6072 13.6283 11.9253 13.1955 11.348 12.6419C10.7943 12.0647 10.3615 11.3827 10.0748 10.6361C10.5505 10.1554 11.385 9.13694 10.9403 8.26947C10.5455 7.50192 9.94088 6.27864 9.94088 6.27766C9.85604 6.10929 9.68369 6.003 9.49513 6.00281H8.49574C7.04029 6.25419 5.98205 7.52413 5.99723 9.00103C5.99723 10.5701 7.8751 13.5843 9.14139 14.8516C10.4077 16.1188 13.4219 17.9957 14.9919 17.9957C16.4688 18.0109 17.7388 16.9526 17.9901 15.4972V14.4978C17.9903 14.3072 17.8822 14.1332 17.7113 14.049Z"
        fill="#FAFAFA"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const FACEBOOK_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 0H3C1.3455 0 0 1.3455 0 3V21C0 22.6545 1.3455 24 3 24H21C22.6545 24 24 22.6545 24 21V3C24 1.3455 22.6545 0 21 0Z"
      fill="#1976D2"
    />
    <path
      d="M20.25 12H16.5V9C16.5 8.172 17.172 8.25 18 8.25H19.5V4.5H16.5C14.0145 4.5 12 6.5145 12 9V12H9V15.75H12V24H16.5V15.75H18.75L20.25 12Z"
      fill="#FAFAFA"
    />
  </svg>
);

export const INSTAGRAM_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 0H7.5C3.3585 0 0 3.3585 0 7.5V16.5C0 20.6415 3.3585 24 7.5 24H16.5C20.6415 24 24 20.6415 24 16.5V7.5C24 3.3585 20.6415 0 16.5 0ZM21.75 16.5C21.75 19.395 19.395 21.75 16.5 21.75H7.5C4.605 21.75 2.25 19.395 2.25 16.5V7.5C2.25 4.605 4.605 2.25 7.5 2.25H16.5C19.395 2.25 21.75 4.605 21.75 7.5V16.5Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M12 6C8.6865 6 6 8.6865 6 12C6 15.3135 8.6865 18 12 18C15.3135 18 18 15.3135 18 12C18 8.6865 15.3135 6 12 6ZM12 15.75C9.933 15.75 8.25 14.067 8.25 12C8.25 9.9315 9.933 8.25 12 8.25C14.067 8.25 15.75 9.9315 15.75 12C15.75 14.067 14.067 15.75 12 15.75Z"
      fill="url(#paint1_linear)"
    />
    <path
      d="M18.4499 6.34948C18.8914 6.34948 19.2494 5.99154 19.2494 5.54999C19.2494 5.10844 18.8914 4.75049 18.4499 4.75049C18.0083 4.75049 17.6504 5.10844 17.6504 5.54999C17.6504 5.99154 18.0083 6.34948 18.4499 6.34948Z"
      fill="url(#paint2_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="2.19697"
        y1="21.8032"
        x2="21.803"
        y2="2.19682"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC107" />
        <stop offset="0.507" stopColor="#F44336" />
        <stop offset="0.99" stopColor="#9C27B0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="7.75747"
        y1="16.2425"
        x2="16.2425"
        y2="7.75747"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC107" />
        <stop offset="0.507" stopColor="#F44336" />
        <stop offset="0.99" stopColor="#9C27B0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="17.8846"
        y1="6.11541"
        x2="19.0152"
        y2="4.98471"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC107" />
        <stop offset="0.507" stopColor="#F44336" />
        <stop offset="0.99" stopColor="#9C27B0" />
      </linearGradient>
    </defs>
  </svg>
);

export const TWITTER_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M24 4.5585C23.1075 4.95 22.1565 5.2095 21.165 5.3355C22.185 4.7265 22.9635 3.7695 23.3295 2.616C22.3785 3.183 21.3285 3.5835 20.2095 3.807C19.3065 2.8455 18.0195 2.25 16.6155 2.25C13.8915 2.25 11.6985 4.461 11.6985 7.1715C11.6985 7.5615 11.7315 7.9365 11.8125 8.2935C7.722 8.094 4.1025 6.1335 1.671 3.147C1.2465 3.8835 0.9975 4.7265 0.9975 5.634C0.9975 7.338 1.875 8.8485 3.183 9.723C2.3925 9.708 1.617 9.4785 0.96 9.117C0.96 9.132 0.96 9.1515 0.96 9.171C0.96 11.562 2.6655 13.548 4.902 14.0055C4.5015 14.115 4.065 14.1675 3.612 14.1675C3.297 14.1675 2.979 14.1495 2.6805 14.0835C3.318 16.032 5.127 17.4645 7.278 17.511C5.604 18.8205 3.4785 19.6095 1.1775 19.6095C0.774 19.6095 0.387 19.5915 0 19.542C2.1795 20.9475 4.7625 21.75 7.548 21.75C16.602 21.75 21.552 14.25 21.552 7.749C21.552 7.5315 21.5445 7.3215 21.534 7.113C22.5105 6.42 23.331 5.5545 24 4.5585Z"
        fill="#03A9F4"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
